import React, { Component } from 'react'
import { NavLink } from '~base/router'
import { branch } from 'baobab-react/higher-order'
import { withRouter } from 'react-router'

import storage from '~base/storage'
import api from '~base/api'
import tree from '~core/tree'

class NavBar extends Component {
  constructor (props) {
    super(props)
    this.state = {
      mobileMenu: 'close',
      redirect: false,
      profileDropdown: 'is-hidden',
      dropCaret: 'fa fa-caret-down'
    }
  }

  async handleLogout () {
    const { history } = this.props

    try {
      await api.del('/user')
    } catch (err) {
      console.log('Error removing token, logging out anyway ...')
    }

    storage.remove('jwt')
    tree.set('jwt', null)
    tree.set('user', null)
    tree.set('loggedIn', false)
    tree.commit()

    history.push('/')
  }

  handleNavbarBurgerClick () {
    if (this.state.mobileMenu === 'open') {
      this.setState({ mobileMenu: 'close' })
    } else {
      this.setState({ mobileMenu: 'open' })
    }
  }

  render () {
    var navbarMenuClassName = 'navbar-menu'
    if (this.state.mobileMenu === 'open') {
      navbarMenuClassName = 'navbar-menu is-active'
    }
    let navButtons, navMainLink, name

    if (this.props.loggedIn) {
      if (tree.get('user')) {
        name = tree.get('user').name
      }

      navButtons = (<div className='navbar-end'>
        <div className='dropdown is-active is-right' ref={this.setWrapperRef}>
          <div className='navbar-item'>
            <NavLink to='/profile'>@{ name }</NavLink>
          </div>
          <div className='navbar-item'>
            <a onClick={() => this.handleLogout()}>Salir</a>
          </div>
        </div>
      </div>)

      navMainLink = (<NavLink className='navbar-item' to='/'>
        <img src='/public/logo.png' style={{ paddingRight: 10 }} />
      </NavLink>)
    } else {
      navButtons = (<div className='navbar-end'>
        <div className='navbar-item'>
          <div className='field is-grouped'>
            <p className='control'>
              <NavLink className='bd-tw-button button' to='/log-in'>Entrar</NavLink>
            </p>
            <p className='control'>
              <NavLink className='bd-tw-button button is-primary' to='/sign-up'>Registro</NavLink>
            </p>
          </div>
        </div>
      </div>)

      navMainLink = (<NavLink className='navbar-item' to='/'>
        <img src='/public/logo.png' style={{ paddingRight: 10 }} />
      </NavLink>)
    }

    return (
      <nav className='navbar topNav'>
        <section className='container'>
          <div className='navbar-brand'>
            {navMainLink}
            <div className='navbar-burger burger' onClick={(e) => this.handleNavbarBurgerClick(e)}>
              <span />
              <span />
              <span />
            </div>
          </div>
          <div className={navbarMenuClassName}>
            <div className='navbar-start'>
              <NavLink className='navbar-item' to='/top' > Top </NavLink>
              <NavLink className='navbar-item' to='/new'> Nuevo </NavLink>
            </div>
            {navButtons}
          </div>
        </section>
      </nav>
    )
  }
}

export default withRouter(branch({
  loggedIn: 'loggedIn'
}, NavBar))



// WEBPACK FOOTER //
// ../frontend/components/navbar.js